import { render } from "./proEmpty.vue?vue&type=template&id=f7a41856"
import script from "./proEmpty.vue?vue&type=script&lang=js"
export * from "./proEmpty.vue?vue&type=script&lang=js"

import "./proEmpty.vue?vue&type=style&index=0&id=f7a41856&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__